// extracted by mini-css-extract-plugin
export var startNow = "style-module--start-now--bc315";
export var startNow__block = "style-module--start-now__block--4043a";
export var startNow__blocks = "style-module--start-now__blocks--d416c";
export var startNow__imgWrapper = "style-module--start-now__img-wrapper--d49a7";
export var startNow__title = "style-module--start-now__title--149fa";
export var startNow__video = "style-module--start-now__video--b3284";
export var startNow__videoBlock = "style-module--start-now__video-block--d7574";
export var startNow__videoWrapper = "style-module--start-now__video-wrapper--5b3ca";